// removed by extract-text-webpack-plugin
module.exports = {"tag":"_1NnMh4PZyQpk5Da9V9jvY6","primary":"_3yht4ey_u4_cZrBNy5144_","secondary":"_1c2yt6Y7KPSEXbwKbgKR6F","success":"_2UsWqcbHP3iFE0se4N6C8R","default":"_2Kf9iItHKmNgPQ3l4fnUUY","dark":"_3Unu9p5MW6462BDZX7kzX2"};


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/atoms/Tag/style.css
// module id = 462
// module chunks = 39